export function to(promise, errorExt) {
  return promise
    .then(({ msg, code, data }) => {
      if (code !== 1) {
        return [msg, undefined]
      }
      return [null, data]
    })
    .catch(err => {
      let msg = { ...err }
      if (errorExt) {
        msg = { ...msg, ...errorExt }
      }
      return [msg, undefined]
    })
}
